const matchHeightElements = () => {
    $('.equipment-block .equipment-block__title').matchHeight({
        property: 'min-height',
    });
    $('.equipment-block .equipment-block__description').matchHeight({
        property: 'min-height',
    });
    $('.products-archive .products-block__item__title').matchHeight({
        property: 'min-height',
    });
    $('.products-archive .products-block__item__description').matchHeight({
        property: 'min-height',
    });
    $('.products-archive span.icon-specification.size-auto').matchHeight({
        property: 'min-height',
    });
    $('.horizontal-list__item p').matchHeight({
        property: 'min-height',
    });
}
export default matchHeightElements;